import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function MarketOpportunity() {
  return <Section background="charcoal" className="text-ivory" data-id="element-212">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-213">
        <FadeIn data-id="element-214">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-215">
            A Generational Market Shift
          </h2>
          <p className="text-lg text-ivory/70" data-id="element-216">
            Fem Entity sits at the intersection of women's economic power,
            digital health transformation, and corporate wellness evolution.
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-217">
        <FadeIn delay={100} data-id="element-218">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-219">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-220">
              $44B
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-221">
              Corporate Wellness TAM
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={200} data-id="element-222">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-223">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-224">
              $8.8B
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-225">
              Serviceable Market
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={300} data-id="element-226">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-227">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-228">
              9.3%
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-229">
              CAGR Expansion
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={400} data-id="element-230">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-231">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-232">
              $94B
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-233">
              Projected by 2026
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={600} data-id="element-234">
        <div className="text-center border-t border-ivory/10 pt-12" data-id="element-235">
          <p className="text-2xl md:text-3xl font-serif italic text-ivory/90" data-id="element-236">
            Women control <span className="text-purple-400" data-id="element-237">$31.8T</span> in
            global discretionary spending.
          </p>
        </div>
      </FadeIn>
    </Section>;
}